import {CapsulableEntity, EntityCapsule, EntityCapsuleProps} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";
import {AgentPresence} from "../rpc/webrpc-client.gen.ts";
import {Veiled} from "../components/Veil.tsx";
import {faLink, faSignalStreamSlash} from "@fortawesome/pro-regular-svg-icons";
import {find} from "lodash";
import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {SheetProps, Stack, useTheme} from "@mui/joy";
import {figureColors} from "../color.tsx";
import {useTranslation} from "react-i18next";

export interface AgentCapsuleProps extends Omit<EntityCapsuleProps, "entity"> {
    agent: CapsulableEntity | undefined;
}

export function AgentCapsule(props: AgentCapsuleProps) {
    const {agent: inAgent, ...rest} = props;
    const {t} = useTranslation();
    let agent = inAgent ?? {displayName: t("unknown")};
    if (!agent.icon) {
        agent = {...agent, icon: iconForEntityType("agent")}
    }
    return <EntityCapsule entity={agent} {...rest}/>;

    // const capsule = <EntityCapsule entity={agent} {...rest}/>
    // return agent.id && linkify
    //     ? <RouterJoyLink to="/agent/$id/timeline" params={{id: agent.id}} underline="hover">
    //         {capsule}</RouterJoyLink>
    //     : capsule;
}

export interface AgentPresenceCapsuleProps {
    presence?: AgentPresence;
    icon?: FontAwesomeIconProps;
}

export function agentPresenceColor(presence: AgentPresence | undefined): SheetProps["color"] {
    if (!presence) {
        return "danger";
    }
    switch (presence.lastShiftEventFlavor) {
        case "BREAK_START":
            return "warning";
        case "BREAK_END":
        case "SHIFT_START":
            return "primary";
        case "SHIFT_END":
            return "neutral";
    }
    return "success";
}

export function AgentPresenceCapsule({presence}: AgentPresenceCapsuleProps) {
    const theme = useTheme();
    const color: SheetProps["color"] = agentPresenceColor(presence);
    const colors = figureColors({
        theme, color, variant: "soft"
    });

    const firstOnlineOutlet = presence
        ? find(presence.outlets, (maybe) => {
            return maybe.connectionStatus === "up";
        }) : undefined;
    return <Veiled child={() =>
        <Stack direction="row" sx={{
            alignItems: "center", justifyContent: "space-around",
            backgroundColor: colors.mainBackground, color: colors.mainForeground,
        }}>
            <AgentCapsule agent={presence?.agent} color={color}/>
            <FontAwesomeIcon icon={firstOnlineOutlet ? faLink : faSignalStreamSlash}/>
        </Stack>}
                   color={color} topcoatGradientPalette="danger" variant="solid"
                   lifted={!!presence?.outlets && presence.outlets.length > 0}/>
}


